
  <div class="cloudinary-feature-img">
    <cl-image loading="lazy" public-id="{{replaceImage(article.image.cloudinary_id)}}" secure="true">
        <cl-transformation width="270" height="160" gravity="face" crop="thumb">
        </cl-transformation>
      </cl-image>
  </div>
 